/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../core/redux/store";
import { RootState } from "../../core/redux/store";
import { logoutUser } from "../../core/redux/apis/auth";
import { useAppDispatch, persistor } from "../../core/redux/store";
import { baseApi } from "../../core/redux/services/baseApi";
import { RESET_STATE } from "../../core/redux/reducer";
import { useLazyGlobalSearchQuery } from "../../core/redux/services/adminSupportApi";
import { checkApiStatus } from "../../core/redux/apis/status";
import { Link, useNavigate } from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import NotificationBell from "./NotificationBell";
import { Search, XCircle } from "react-feather";
import { all_routes } from "../../Router/all_routes";
import { logo } from "../../assets/images";
const Header = () => {
  //SERVER STATUS
  // const dispatch = useDispatch<AppDispatch>();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const refreshToken = useSelector((state: RootState) => state.auth.refreshToken);

  const { data, loading, error } = useSelector((state: any) => state.status);
  // AUTH STATE
  const { user, accessToken } = useSelector((state: any) => state.auth);


  useEffect(() => {
    dispatch(checkApiStatus());
  }, [dispatch]);

  // LOGOUT
  //
  // Not gated on `refreshToken` any more. If it is missing there is nothing to
  // revoke server-side, but the local session still has to be torn down — the
  // old guard meant the button did literally nothing in exactly the state where
  // signing out matters most.
  const handleLogout = () => {
    dispatch(
      logoutUser(refreshToken, () => {
        // Every slice except the RTK cache is persisted, and the `logout`
        // reducer only clears `auth` — so tenant/user/customer/invoice/store
        // all kept the previous account's data in localStorage after signing
        // out. On a shared admin machine that is the next person's problem.
        //
        // Order matters. Reset the store FIRST: purge() only deletes the
        // persisted blob, and the still-populated store writes it straight back
        // (globalProduct was observed surviving a logout that way).
        dispatch({ type: RESET_STATE });
        dispatch(baseApi.util.resetApiState());
        persistor.purge().catch(() => undefined);
        navigate(route.signin, { replace: true });
      })
    );
  };
  const route = all_routes;

  // The header asserted "Super Admin" in two places regardless of who was signed
  // in. platformSupport exists precisely so support staff are NOT superadmins
  // ([[impersonation-p1]]), so a label that cannot be wrong is worse than none.
  const displayRole = React.useMemo(() => {
    const roles: string[] = user?.roles ?? [];
    if (!roles.length) return user?.email ?? "";
    const pretty: Record<string, string> = {
      superAdmin: "Super Admin",
      platformSupport: "Platform Support",
      tenantAdmin: "Tenant Admin",
    };
    return roles.map((r) => pretty[r] ?? r).join(", ");
  }, [user]);

  // ── Global search ──
  // Debounced so a lookup is one request per pause, not one per keystroke: the
  // backend classifies the term and fans out across tables, so firing it on
  // every character is exactly the load pattern P5 was designed to avoid.
  const [term, setTerm] = useState("");
  const [runSearch, { data: searchData, isFetching: searching }] = useLazyGlobalSearchQuery();
  const hits = searchData?.hits ?? [];

  useEffect(() => {
    const q = term.trim();
    if (q.length < 2) return;
    const t = setTimeout(() => { runSearch(q); }, 300);
    return () => clearTimeout(t);
  }, [term, runSearch]);

  const submitSearch = () => {
    const q = term.trim();
    if (!q) return;
    navigate(`${route.globalsearch}?q=${encodeURIComponent(q)}`);
    setTerm("");
  };

  const [toggle, SetToggle] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const isElementVisible = (element: HTMLElement | null | undefined): boolean => {
    return !!element && (element.offsetWidth > 0 || element.offsetHeight > 0);
  };

  const slideDownSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        (submenu as HTMLElement).style.display = "block";
      }
    }
  };

  const slideUpSubmenu = () => {
    const subdropPlusUl = document.getElementsByClassName("subdrop");
    for (let i = 0; i < subdropPlusUl.length; i++) {
      const submenu = subdropPlusUl[i].nextElementSibling;
      if (submenu && submenu.tagName.toLowerCase() === "ul") {
        (submenu as HTMLElement).style.display = "none";
      }
    }
  };

  useEffect(() => {
    const handleMouseover = (e: MouseEvent) => {
      e.stopPropagation();

      const body = document.body;
      const toggleBtn = document.getElementById("toggle_btn");

      if (
        body.classList.contains("mini-sidebar") &&
        isElementVisible(toggleBtn)
      ) {
        const target = (e.target as HTMLElement | null)?.closest(".sidebar, .header-left");

        if (target) {
          body.classList.add("expand-menu");
          slideDownSubmenu();
        } else {
          body.classList.remove("expand-menu");
          slideUpSubmenu();
        }

        e.preventDefault();
      }
    };

    document.addEventListener("mouseover", handleMouseover);

    return () => {
      document.removeEventListener("mouseover", handleMouseover);
    };
  }, []); // Empty dependency array ensures that the effect runs only once on mount
  useEffect(() => {
    const handleFullscreenChange = () => {
      const doc: any = document;
      setIsFullscreen(
        !!(
          doc.fullscreenElement ||
          doc.mozFullScreenElement ||
          doc.webkitFullscreenElement ||
          doc.msFullscreenElement
        )
      );
    };

    document.addEventListener("fullscreenchange", handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", handleFullscreenChange);
    document.addEventListener("msfullscreenchange", handleFullscreenChange);

    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
      document.removeEventListener(
        "mozfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "webkitfullscreenchange",
        handleFullscreenChange
      );
      document.removeEventListener(
        "msfullscreenchange",
        handleFullscreenChange
      );
    };
  }, []);
  const handlesidebar = () => {
    document.body.classList.toggle("mini-sidebar");
    SetToggle((current) => !current);
  };
  const expandMenu = () => {
    document.body.classList.remove("expand-menu");
  };
  const expandMenuOpen = () => {
    document.body.classList.add("expand-menu");
  };
  const sidebarOverlay = () => {
    document?.querySelector(".main-wrapper")?.classList?.toggle("slide-nav");
    document?.querySelector(".sidebar-overlay")?.classList?.toggle("opened");
    document?.querySelector("html")?.classList?.toggle("menu-opened");
  };

  let pathname = window.location.pathname;

  const exclusionArray = [
    "/reactjs/template/dream-pos/index-three",
    "/reactjs/template/dream-pos/index-one",
  ];
  if (exclusionArray.indexOf(window.location.pathname) >= 0) {
    return <></>;
  }




  const toggleFullscreen = (elem?: Element | null) => {
    const doc: any = document;
    elem = elem || document.documentElement;
    if (
      !doc.fullscreenElement &&
      !doc.mozFullScreenElement &&
      !doc.webkitFullscreenElement &&
      !doc.msFullscreenElement
    ) {
      if ((elem as any).requestFullscreen) {
        (elem as any).requestFullscreen();
      } else if ((elem as any).msRequestFullscreen) {
        (elem as any).msRequestFullscreen();
      } else if ((elem as any).mozRequestFullScreen) {
        (elem as any).mozRequestFullScreen();
      } else if ((elem as any).webkitRequestFullscreen) {
        (elem as any).webkitRequestFullscreen((Element as any).ALLOW_KEYBOARD_INPUT);
      }
    } else {
      if (doc.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
      } else if (doc.mozCancelFullScreen) {
        doc.mozCancelFullScreen();
      } else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen();
      }
    }
  };

  return (
    <>
      <div className="header">
        {/* Logo */}
        <div
          className={`header-left ${toggle ? "" : "active"}`}
          onMouseLeave={expandMenu}
          onMouseOver={expandMenuOpen}
        >
          <Link to="/dashboard" className="logo logo-normal">
            <ImageWithBasePath src={logo} alt="img" />
          </Link>

          {/* <Link to="/dashboard" className="logo logo-normal">
            <ImageWithBasePath src="assets/img/logo.png" alt="img" />
          </Link>
          <Link to="/dashboard" className="logo logo-white">
            <ImageWithBasePath src="assets/img/logo-white.png" alt="img" />
          </Link>
          <Link to="/dashboard" className="logo-small">
            <ImageWithBasePath src="assets/img/logo-small.png" alt="img" />
          </Link> */}
          <Link
            id="toggle_btn"
            to="#"
            style={{
              display: pathname.includes("tasks")
                ? "none"
                : pathname.includes("compose")
                  ? "none"
                  : "",
            }}
            onClick={handlesidebar}
          >
            <FeatherIcon icon="chevrons-left" className="feather-16" />
          </Link>
        </div>
        {/* /Logo */}
        <Link
          id="mobile_btn"
          className="mobile_btn"
          to="#"
          onClick={sidebarOverlay}
        >
          <span className="bar-icon">
            <span />
            <span />
            <span />
          </span>
        </Link>
        {/* Header Menu */}
        <ul className="nav user-menu">
          {/* Search — wired to the platform-wide /admin/search built in P5.
              What stood here was the template's mock: a form with no handler,
              three hardcoded "recent searches" pointing at #, boilerplate help
              text, and three invented customers with stock avatars. It looked
              like a working search and answered nothing. */}
          <li className="nav-item nav-searchinputs">
            <div className="top-nav-search">
              <Link to="#" className="responsive-search">
                <Search />
              </Link>
              <form
                className="dropdown"
                onSubmit={(e) => {
                  e.preventDefault();
                  submitSearch();
                }}
              >
                <div className="searchinputs" id="dropdownMenuClickable">
                  <input
                    type="text"
                    placeholder="Search anything — id, email, SUP- ref, request id"
                    value={term}
                    onChange={(e) => setTerm(e.target.value)}
                  />
                  <div className="search-addon">
                    {term && (
                      <span role="button" onClick={() => setTerm("")}>
                        <XCircle className="feather-14" />
                      </span>
                    )}
                  </div>
                </div>

                {/* Shown only once there is something to say, rather than a
                    permanently-open panel of invented content. */}
                {term.trim().length >= 2 && (
                  <div className="dropdown-menu search-dropdown show" style={{
                      width: 380,
                      // The template CSS pins .search-dropdown to height:315px —
                      // sized for the three mock sections that used to fill it.
                      // Real results vary, so size to content and cap instead.
                      height: "auto",
                      maxHeight: 420,
                      overflowY: "auto",
                    }}>
                    <div className="search-info">
                      {searching && <p className="mb-0 text-muted">Searching…</p>}

                      {!searching && hits.length === 0 && (
                        <p className="mb-0 text-muted">
                          Nothing matches “{term.trim()}”.
                        </p>
                      )}

                      {!searching && hits.length > 0 && (
                        <ul className="search-tags" style={{ display: "block" }}>
                          {hits.slice(0, 6).map((h: any) => (
                            <li key={`${h.kind}:${h.id}`} style={{ display: "block", marginBottom: 6 }}>
                              <Link
                                to={h.link || route.globalsearch}
                                onClick={() => setTerm("")}
                                style={{ display: "block" }}
                              >
                                <span className="badge bg-light text-dark me-2">{h.kind}</span>
                                {h.label}
                                {h.tenantName ? (
                                  <span className="text-muted"> · {h.tenantName}</span>
                                ) : null}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}

                      {!searching && hits.length > 0 && (
                        <Link to={`${route.globalsearch}?q=${encodeURIComponent(term.trim())}`} onClick={() => setTerm("")}>
                          See all {hits.length} results
                        </Link>
                      )}
                    </div>
                  </div>
                )}
              </form>
            </div>
          </li>
          {/* /Search */}
          <div>
            {loading && <>Checking...</>}
            {error && <p>Server Down: {error}</p>}
            {data && <p>API Status: {data.message}</p>}
          </div>

          {/* Select Store */}
          {/* <li className="nav-item dropdown has-arrow main-drop select-store-dropdown">
            <Link
              to="#"
              className="dropdown-toggle nav-link select-store"
              data-bs-toggle="dropdown"
            >
              <span className="user-info">
                <span className="user-letter">
                  <ImageWithBasePath
                    src="assets/img/store/store-01.png"
                    alt="Store Logo"
                    className="img-fluid"
                  />
                </span>
                <span className="user-detail">
                  <span className="user-name">Select Store</span>
                </span>
              </span>
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/store/store-01.png"
                  alt="Store Logo"
                  className="img-fluid"
                />{" "}
                Grocery Alpha
              </Link>
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/store/store-02.png"
                  alt="Store Logo"
                  className="img-fluid"
                />{" "}
                Grocery Apex
              </Link>
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/store/store-03.png"
                  alt="Store Logo"
                  className="img-fluid"
                />{" "}
                Grocery Bevy
              </Link>
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/store/store-04.png"
                  alt="Store Logo"
                  className="img-fluid"
                />{" "}
                Grocery Eden
              </Link>
            </div>
          </li> */}
          {/* /Select Store */}

          {/* Flag */}
          {/* <li className="nav-item dropdown has-arrow flag-nav nav-item-box">
            <Link
              className="nav-link dropdown-toggle"
              data-bs-toggle="dropdown"
              to="#"
              role="button"
            >
           
              <ImageWithBasePath
                src="assets/img/flags/us.png"
                alt="img"
                height={16}
              />
            </Link>
            <div className="dropdown-menu dropdown-menu-right">
              <Link to="#" className="dropdown-item active">
                <ImageWithBasePath
                  src="assets/img/flags/us.png"
                  alt="img"
                  height={16}
                />
                English
              </Link>
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/flags/fr.png"
                  alt="img"
                  height={16}
                />{" "}
                French
              </Link>
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/flags/es.png"
                  alt="img"
                  height={16}
                />{" "}
                Spanish
              </Link>
              <Link to="#" className="dropdown-item">
                <ImageWithBasePath
                  src="assets/img/flags/de.png"
                  alt="img"
                  height={16}
                />{" "}
                German
              </Link>
            </div>
          </li> */}
          {/* /Flag */}
          <li className="nav-item nav-item-box">
            <Link
              to="#"
              id="btnFullscreen"
              onClick={() => toggleFullscreen()}
              className={isFullscreen ? "Exit Fullscreen" : "Go Fullscreen"}
            >
              {/* <i data-feather="maximize" /> */}
              <FeatherIcon icon="maximize" />
            </Link>
          </li>
          {/* The mail icon pointed at /email — a route that does not exist in
              router.link.tsx — and carried a hardcoded "1" badge that never
              changed. Removed rather than faked: NotificationBell is directly
              beside it and already shows a real unread count. */}
          {/* Notifications */}
          <NotificationBell />
          {/* /Notifications */}
          <li className="nav-item nav-item-box">
            <Link to="/general-settings">
              {/* <i data-feather="settings" /> */}
              <FeatherIcon icon="settings" />
            </Link>
          </li>
          <li className="nav-item dropdown has-arrow main-drop">
            <Link
              to="#"
              className="dropdown-toggle nav-link userset"
              data-bs-toggle="dropdown"
            >
              <span className="user-info">
                <span className="user-letter">
                  <ImageWithBasePath
                    src="assets/img/profiles/avator1.jpg"
                    alt="img"
                    className="img-fluid"
                  />
                </span>
                <span className="user-detail">
                  <span className="user-name">{user?.name ?? user?.email ?? "Account"}</span>
                  <span className="user-role">{displayRole}</span>
                </span>
              </span>
            </Link>
            <div className="dropdown-menu menu-drop-user">
              <div className="profilename">
                <div className="profileset">
                  <span className="user-img">
                    <ImageWithBasePath
                      src="assets/img/profiles/avator1.jpg"
                      alt="img"
                    />
                    <span className="status online" />
                  </span>
                  <div className="profilesets">
                    <h6>{user?.name ?? user?.email ?? "Account"}</h6>
                    <h5>{displayRole}</h5>
                  </div>
                </div>
                <hr className="m-0" />
                {/* route.route */}
                <Link className="dropdown-item" to={route.profile}>
                  <i className="me-2" data-feather="user" /> My Profile
                </Link>
                <Link className="dropdown-item" to={route.generalsettings}>
                  <i className="me-2" data-feather="settings" />
                  Settings
                </Link>
                <hr className="m-0" />
                {/* <Link className="dropdown-item logout pb-0" to="/signin">
                  <ImageWithBasePath
                    src="assets/img/icons/log-out.svg"
                    alt="img"
                    className="me-2"
                  />
                  Logout
                </Link> */}
                <button
                  onClick={handleLogout}
                  className="dropdown-item logout pb-0 flex items-center w-full bg-transparent border-0 text-left"
                >
                  <ImageWithBasePath
                    src="assets/img/icons/log-out.svg"
                    alt="img"
                    className="me-2"
                  />
                  Logout
                </button>
              </div>
            </div>
          </li>
        </ul>
        {/* /Header Menu */}
        {/* Mobile Menu */}
        <div className="dropdown mobile-user-menu">
          <Link
            to="#"
            className="nav-link dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            {/* These were relative paths ("profile", not "/profile"), so from a
                nested route such as /tenants/:id/360 they resolved to
                /tenants/:id/360/profile — a route that does not exist. Use the
                same all_routes constants the desktop menu uses. */}
            <Link className="dropdown-item" to={route.profile}>
              My Profile
            </Link>
            <Link className="dropdown-item" to={route.generalsettings}>
              Settings
            </Link>
            {/* Was <Link to="signin">, which navigated to the sign-in page while
                leaving the tokens and the whole persisted store intact — it
                looked like signing out without being one. */}
            <button
              onClick={handleLogout}
              className="dropdown-item logout bg-transparent border-0 text-left w-100"
            >
              Logout
            </button>
          </div>
        </div>
        {/* /Mobile Menu */}
      </div>
    </>
  );
};

export default Header;
